// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"3dd8f9eb98ec15e203ad","966":"22cc36667e255414ec44"}[chunkId] + ".js";
};